import * as yup from "yup";

export const monitoringCgsInitialDataSchema: yup.ObjectSchema<any> = yup.object().shape({
  is_fullfilled_used_amount: yup.boolean(),
  is_loan_documentation_provided: yup.boolean(),
  is_deadline_approve: yup.boolean(),
  actual_municipality: yup
    .string()
    .required("გთხოვთ, მიუთითოთ კომპანიის საქმიანობის განხორციელების რეგიონი/მუნიციპალიტეტი.")
    .typeError("გთხოვთ, მიუთითოთ კომპანიის საქმიანობის განხორციელების რეგიონი/მუნიციპალიტეტი."),
  mountainous_settlement: yup.string().required("გთხოვთ, მიუთითოთ მთიანი რეგიონის დასახლება").typeError("გთხოვთ, მიუთითოთ მთიანი რეგიონის დასახლება"),
  actual_address: yup.string().required("გთხოვთ, მიუთითოთ მისამართი(სოფელი/დაბა/ქუჩა/ნომერი)"),
  cadastral_code: yup.string().required("გთხოვთ, მიუთითოთ საკადასტრო კოდი"),
  representative_name: yup.string().required("გთხოვთ, მიუთითოთ კომპანიის წარმომადგენელი (ხელმომწერი) პირის სახელი და გვარი"),
  representative_phone: yup.string().required("გთხოვთ, მიუთითოთ კომპანიის წარმომადგენელი (ხელმომწერი) პირის ტელ. ნომერი"),
  representative_position: yup.string().required("გთხოვთ, მიუთითოთ კომპანიის წარმომადგენელი (ხელმომწერი) პირის პოზიცია"),
  representative_id_number: yup.string().required("გთხოვთ, მიუთითოთ კომპანიის წარმომადგენელი (ხელმომწერი) პირის პირადი ნომერი"),
  representative_email: yup.string().email("ელ. ფოსტა არ არის ვალიდური").required("გთხოვთ, მიუთითოთ კომპანიის წარმომადგენელი (ხელმომწერი) პირის ელ. ფოსტა"),
  used_amount: yup.number().required("გთხოვთ, მიუთითოთ ათვისებული თანხის მოცულობა.").min(1, "გთხოვთ, მიუთითოთ ათვისებული თანხის მოცულობა."),
  unfulfilled_used_amount_reason: yup.string().when("is_fullfilled_used_amount", (a: boolean, field) => {
    if (!a) {
      return field.required("გთხოვთ, მიუთითოთ არდაკმაყოფილებლის მიზეზი");
    }
    return field.notRequired();
  }),
  unfulfilled_used_amount_month_day: yup.number().when("is_fullfilled_used_amount", (a: boolean, field) => {
    if (!a) {
      return field
        .required("გთხოვთ, მიუთითოთ დარღვევის აღმოსაფხვრელად მიცემული გონივრული ვადა (თვე/დღე)")
        .min(1, "გთხოვთ, მიუთითოთ დარღვევის აღმოსაფხვრელად მიცემული გონივრული ვადა (თვე/დღე)");
    }
    return field.notRequired();
  }),
  unfulfilled_used_amount_recommendation_reason: yup.string().when("is_deadline_approve", (a: boolean[], field) => {
    if (!a) {
      return field.required("გთხოვთ, მიუთითოთ დარღვევის აღმოსაფხვრელად მიცემული გონივრული ვადისთვის რეკომენდაცია");
    }
    return field.notRequired();
  }),
  monitoring_new_deadline: yup.date().when("is_fullfilled_used_amount", (a: boolean, field) => {
    if (!a) {
      return field.required("დაფიქსირდა შეცდომა, ახალი ვადა არ დაგენერირდა, გთხოვთ მიმართოთ ადმინისტრაციას");
    }
    return field.nullable().notRequired();
  }),
  is_taken_business_loan_leasing: yup
    .boolean()
    .required("გთხოვთ მიუთითოთ, აღებული გაქვთ თუ არა ბიზნეს სესხი/ლიზინგი")
    .typeError("გთხოვთ მიუთითოთ, აღებული გაქვთ თუ არა ბიზნეს სესხი/ლიზინგი"),
  project_activities: yup.array().of(yup.mixed().required("გთხოვთ მიუთითოთ NACE კოდი.")).min(1, "მიუთითეთ მინიმუმ ერთი აქტივობა."),
  additional_comments: yup.string().required("გთხოვთ, მიუთითოთ დამატებითი კომენტარი"),
});

export const monitoringCgsInitialDataSchemaSubmit: yup.ObjectSchema<any> = yup.object().shape({
  machine_equipment_equipment: yup.number(),
  vehicles_special_technic: yup.number(),
  purchase_building_land: yup.number(),
  building_repairs: yup.number(),
  funds_turnover: yup.number(),
  is_repayment_amount: yup.boolean(),
  repayment_amount: yup.number().when("is_repayment_amount", (a: boolean, field) => {
    if (a) {
      return field
        .required("გთხოვთ, მიუთითოთ ნაწილობრივ/სრულად დაფარული სესხის თანხა)")
        .min(1, "გთხოვთ, მიუთითოთ ნაწილობრივ/სრულად დაფარული სესხის თანხა");
    }
    return field.notRequired();
  }),
  is_fullfilled_used_amount: yup.boolean(),
  is_deadline_approve: yup.boolean(),
  actual_municipality: yup
    .string()
    .required("გთხოვთ, მიუთითოთ კომპანიის საქმიანობის განხორციელების რეგიონი/მუნიციპალიტეტი.")
    .typeError("გთხოვთ, მიუთითოთ კომპანიის საქმიანობის განხორციელების რეგიონი/მუნიციპალიტეტი."),
  mountainous_settlement: yup.string().required("გთხოვთ, მიუთითოთ მთიანი რეგიონის დასახლება").typeError("გთხოვთ, მიუთითოთ მთიანი რეგიონის დასახლება"),
  actual_address: yup.string().required("გთხოვთ, მიუთითოთ მისამართი(სოფელი/დაბა/ქუჩა/ნომერი)"),
  cadastral_code: yup.string().required("გთხოვთ, მიუთითოთ საკადასტრო კოდი"),
  representative_name: yup.string().required("გთხოვთ, მიუთითოთ კომპანიის წარმომადგენელი (ხელმომწერი) პირის სახელი და გვარი"),
  representative_phone: yup.string().required("გთხოვთ, მიუთითოთ კომპანიის წარმომადგენელი (ხელმომწერი) პირის ტელ. ნომერი"),
  representative_position: yup.string().required("გთხოვთ, მიუთითოთ კომპანიის წარმომადგენელი (ხელმომწერი) პირის პოზიცია"),
  representative_id_number: yup.string().required("გთხოვთ, მიუთითოთ კომპანიის წარმომადგენელი (ხელმომწერი) პირის პირადი ნომერი"),
  representative_email: yup.string().email("ელ. ფოსტა არ არის ვალიდური").required("გთხოვთ, მიუთითოთ კომპანიის წარმომადგენელი (ხელმომწერი) პირის ელ. ფოსტა"),
  used_amount: yup.number().required("გთხოვთ, მიუთითოთ ათვისებული თანხის მოცულობა.").min(1, "გთხოვთ, მიუთითოთ ათვისებული თანხის მოცულობა."),
  unfulfilled_used_amount_reason: yup.string().when("is_fullfilled_used_amount", (a: boolean, field) => {
    if (!a) {
      return field.required("გთხოვთ, მიუთითოთ არდაკმაყოფილებლის მიზეზი");
    }
    return field.notRequired();
  }),
  unfulfilled_used_amount_month_day: yup.number().when("is_fullfilled_used_amount", (a: boolean, field) => {
    if (!a) {
      return field
        .required("გთხოვთ, მიუთითოთ დარღვევის აღმოსაფხვრელად მიცემული გონივრული ვადა (თვე/დღე)")
        .min(1, "გთხოვთ, მიუთითოთ დარღვევის აღმოსაფხვრელად მიცემული გონივრული ვადა (თვე/დღე)");
    }
    return field.notRequired();
  }),
  unfulfilled_used_amount_recommendation_reason: yup.string().when("is_deadline_approve", (a: boolean[], field) => {
    if (!a) {
      return field.required("გთხოვთ, მიუთითოთ დარღვევის აღმოსაფხვრელად მიცემული გონივრული ვადისთვის რეკომენდაცია");
    }
    return field.notRequired();
  }),
  monitoring_new_deadline: yup.date().when("is_fullfilled_used_amount", (a: boolean, field) => {
    if (!a) {
      return field.required("დაფიქსირდა შეცდომა, ახალი ვადა არ დაგენერირდა, გთხოვთ მიმართოთ ადმინისტრაციას");
    }
    return field.nullable().notRequired();
  }),
  project_activities: yup.array().of(yup.mixed().required("გთხოვთ მიუთითოთ NACE კოდი.")).min(1, "მიუთითეთ მინიმუმ ერთი აქტივობა."),
  attached_documents: yup
    .object({
      monitoring_attachments: yup
        .array()
        .of(yup.mixed().required("გთხოვთ ატვირთოთ დოკუმენტი/ფაილი"))
        .min(1, "გთხოვთ ატვირთოთ დოკუმენტი/ფაილი"),

      machine_equipment_equipment: yup
        .array()
        .of(yup.mixed())
        .when("$machine_equipment_equipment", {
          is: (val: number) => val > 0,
          then: (schema) =>
            schema.min(
              1,
              "გთხოვთ, ატვირთოთ მანქანა - დანადგარები/აღჭურვილობის დამადასტურებელი დოკუმენტაცია"
            ),
          otherwise: (schema) => schema.notRequired(),
        }),

      vehicles_special_technic: yup
        .array()
        .of(yup.mixed())
        .when("$vehicles_special_technic", {
          is: (val: number) => val > 0,
          then: (schema) =>
            schema.min(
              1,
              "გთხოვთ, ატვირთოთ სატრანსპორტო საშუალებები/სპეც. ტექნიკის დამადასტურებელი დოკუმენტი/ფაილი"
            ),
          otherwise: (schema) => schema.notRequired(),
        }),

      purchase_building_land: yup
        .array()
        .of(yup.mixed())
        .when("$purchase_building_land", {
          is: (val: number) => val > 0,
          then: (schema) =>
            schema.min(
              1,
              "გთხოვთ, ატვირთოთ შენობა ნაგებობის/მიწის შეძენის დამადასტურებელი დოკუმენტი/ფაილი"
            ),
          otherwise: (schema) => schema.notRequired(),
        }),

      building_repairs: yup
        .array()
        .of(yup.mixed())
        .when("$building_repairs", {
          is: (val: number) => val > 0,
          then: (schema) =>
            schema.min(
              1,
              "გთხოვთ, ატვირთოთ მშენებლობა/რემონტის დამადასტურებელი დოკუმენტი/ფაილი"
            ),
          otherwise: (schema) => schema.notRequired(),
        }),

      funds_turnover: yup
        .array()
        .of(yup.mixed())
        .when("$funds_turnover", {
          is: (val: number) => val > 0,
          then: (schema) =>
            schema.min(
              1,
              "გთხოვთ, ატვირთოთ საბრუნავი საშუალებების დამადასტურებელი დოკუმენტი/ფაილი"
            ),
          otherwise: (schema) => schema.notRequired(),
        }),

      repayment_amount: yup
        .array()
        .of(yup.mixed())
        .when("$repayment_amount", {
          is: (val: number) => val > 0,
          then: (schema) =>
            schema.min(
              1,
              "გთხოვთ, ატვირთოთ ნაწილობრივ/სრულად დაფარული სესხის თანხის დამადასტურებელი დოკუმენტი/ფაილი"
            ),
          otherwise: (schema) => schema.notRequired(),
        }),
    })
    .required()
    .defined(),

  additional_comments: yup.string().required("გთხოვთ, მიუთითოთ დამატებითი კომენტარი"),
});
